var J = Object.defineProperty;
var W = Object.getOwnPropertySymbols;
var A = Object.prototype.hasOwnProperty, K = Object.prototype.propertyIsEnumerable;
var D = (c, r, u) => r in c ? J(c, r, { enumerable: !0, configurable: !0, writable: !0, value: u }) : c[r] = u, V = (c, r) => {
  for (var u in r || (r = {}))
    A.call(r, u) && D(c, u, r[u]);
  if (W)
    for (var u of W(r))
      K.call(r, u) && D(c, u, r[u]);
  return c;
};
var P = (c, r, u) => new Promise((N, t) => {
  var _ = (a) => {
    try {
      d(u.next(a));
    } catch (g) {
      t(g);
    }
  }, h = (a) => {
    try {
      d(u.throw(a));
    } catch (g) {
      t(g);
    }
  }, d = (a) => a.done ? N(a.value) : Promise.resolve(a.value).then(_, h);
  d((u = u.apply(c, r)).next());
});
import "../../../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import Q from "../formMixin.js";
import { postRuleValidate as X } from "../../../../request/commoditycenter/form/ruleValidate/post.js";
import { postCodes as Z } from "../../../../request/commoditycenter/commodity/classification/dictionary/rela/codes/post.js";
import { useLanguage as $ } from "../../../../utils/useLanguage.js";
import { defineComponent as ee, useTemplateRef as le, watch as B, onMounted as ae, resolveComponent as te, openBlock as oe, createElementBlock as se, createElementVNode as R, createVNode as l, withCtx as s, createTextVNode as M, Fragment as ne } from "../../../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as U, unref as e } from "../../../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { useMessage as de } from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import ie from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import ue from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import re from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/Form.js";
import pe from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/legacy-grid/src/Row.js";
import m from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/legacy-grid/src/Col.js";
import f from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/FormItem.js";
import E from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
import F from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input-number/src/InputNumber.js";
import y from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
import me from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/RadioGroup.js";
import O from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/Radio.js";
import { toDisplayString as C } from "../../../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import T from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import fe from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const ce = { class: "tw:text-[#909399]" }, ve = { style: { display: "flex", "justify-content": "center", gap: "8px", "margin-top": "16px" } }, Ee = /* @__PURE__ */ ee({
  __name: "guahuabihua",
  props: {
    options: {},
    locale: {}
  },
  emits: ["hide-dialog", "onSuccess"],
  setup(c, { expose: r, emit: u }) {
    const { i18n: N } = $(), { t } = N.global, _ = le("guahuabihuaContainer"), h = U(null), { formSelect: d, formData: a, rules: g, allowEditFun: p, setDefault: j, setRequired: z } = Q(), L = de(), k = c;
    B(
      () => k.locale,
      (i) => {
        N.global.locale.value = i || "zh-CN";
      },
      { immediate: !0 }
    );
    const x = u, b = U(!1), I = U(!0), w = (i) => {
      var o;
      return ((o = d.value.find((v) => v.code === i)) == null ? void 0 : o.values) || [];
    }, S = () => {
      x("hide-dialog");
    }, Y = (i) => {
      console.log("成品宽变化:", i);
    }, q = () => P(this, null, function* () {
      if (h.value)
        try {
          yield h.value.validate(), b.value = !0;
          const i = yield X([
            {
              data: JSON.stringify(a),
              classificationCode: "FL_TYdingzhi"
            }
          ]);
          b.value = !1, i != null && i.status && (L.success(t("操作成功")), x("onSuccess", V({}, a)), x("hide-dialog"));
        } catch (i) {
          b.value = !1, console.error("提交失败:", i);
        }
    }), H = () => P(this, null, function* () {
      const { commodityId: i } = k.options;
      if (!i) {
        console.warn("缺少commodityId，无法获取分类数据");
        return;
      }
      try {
        b.value = !0;
        const o = yield Z({
          commodityId: String(i),
          classificationCode: "FL_TYdingzhi",
          codes: []
        });
        if (b.value = !1, o) {
          d.value = o;
          const v = [
            { name: "remark", message: t("请输入"), type: "" },
            { name: "deliveryMethod", message: t("请选择配送方式"), type: "" },
            { name: "urgent", message: t("请选择"), type: "" },
            { name: "roomName", message: t("请输入"), type: "" },
            { name: "attachments", message: t("请选择"), type: "" },
            { name: "productHeight", message: t("请输入"), type: "" },
            { name: "productWidth", message: t("请输入"), type: "" },
            { name: "installationMethod", message: t("请选择"), type: "" },
            { name: "manualRopeInstallPosition", message: t("请选择"), type: "" },
            { name: "machineInstallPosition", message: t("请选择"), type: "" },
            { name: "openModel", message: t("请选择"), type: "" },
            { name: "ropeLength", message: t("请输入"), type: "" }
          ];
          z(v, o), j(v, o);
        }
      } catch (o) {
        b.value = !1, L.error("获取数据失败"), console.error("数据获取错误:", o);
      }
    }), G = () => {
      Object.assign(a, {
        remark: "",
        isStandard: "否",
        roomName: "",
        urgent: "否",
        deliveryMethod: "",
        attachments: [],
        productHeight: null,
        productWidth: null,
        installationMethod: "",
        manualRopeInstallPosition: "",
        machineInstallPosition: "",
        openModel: "",
        ropeLength: null
      });
    };
    return B(
      () => k.options,
      (i) => {
        G(), Object.keys(a).forEach((o) => {
          const v = o;
          i[v] !== void 0 && (a[v] = i[v] || a[v]);
        }), H();
      },
      { immediate: !0, deep: !0 }
    ), ae(() => {
      H();
    }), r({
      guahuabihuaForm: h,
      loading: b,
      isShowDialog: I,
      formData: a
    }), (i, o) => {
      const v = te("op-file-upload");
      return oe(), se(ne, null, [
        R("div", {
          ref_key: "guahuabihuaContainer",
          ref: _
        }, null, 512),
        l(e(fe), {
          bordered: "",
          show: I.value,
          "onUpdate:show": o[12] || (o[12] = (n) => I.value = n),
          "mask-closable": !1,
          to: _.value || "body",
          class: "tw:!text-left"
        }, {
          default: s(() => [
            l(e(ie), {
              class: "tw:!w-[50%] tw:!box-border tw:!text-left",
              title: e(t)("定制"),
              bordered: !1,
              role: "dialog",
              closable: "",
              onClose: S
            }, {
              default: s(() => [
                l(e(ue), { show: b.value }, {
                  default: s(() => [
                    l(e(re), {
                      model: e(a),
                      rules: e(g),
                      ref_key: "guahuabihuaForm",
                      ref: h,
                      "label-placement": "left",
                      "label-width": "130px",
                      class: "op-clear"
                    }, {
                      default: s(() => [
                        l(e(pe), null, {
                          default: s(() => [
                            l(e(m), { span: 24 }, {
                              default: s(() => [
                                l(e(f), {
                                  label: e(t)("房间名"),
                                  path: "roomName"
                                }, {
                                  default: s(() => [
                                    l(e(E), {
                                      disabled: !e(p)(e(d), "roomName"),
                                      value: e(a).roomName,
                                      "onUpdate:value": o[0] || (o[0] = (n) => e(a).roomName = n),
                                      clearable: "",
                                      class: "tw:!w-[50%]"
                                    }, null, 8, ["disabled", "value"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            l(e(m), { span: 24 }, {
                              default: s(() => [
                                l(e(f), {
                                  label: e(t)("成品高（毫米）"),
                                  path: "productHeight"
                                }, {
                                  default: s(() => [
                                    l(e(F), {
                                      disabled: !e(p)(e(d), "productHeight"),
                                      value: e(a).productHeight,
                                      "onUpdate:value": o[1] || (o[1] = (n) => e(a).productHeight = n),
                                      "show-button": !1,
                                      min: 0,
                                      class: "tw:!w-[50%]"
                                    }, null, 8, ["disabled", "value"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            l(e(m), { span: 24 }, {
                              default: s(() => [
                                l(e(f), {
                                  label: e(t)("成品宽（毫米）"),
                                  path: "productWidth"
                                }, {
                                  default: s(() => [
                                    l(e(F), {
                                      disabled: !e(p)(e(d), "productWidth"),
                                      value: e(a).productWidth,
                                      "onUpdate:value": [
                                        o[2] || (o[2] = (n) => e(a).productWidth = n),
                                        Y
                                      ],
                                      "show-button": !1,
                                      min: 0,
                                      class: "tw:!w-[50%]"
                                    }, null, 8, ["disabled", "value"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            l(e(m), { span: 24 }, {
                              default: s(() => [
                                l(e(f), {
                                  label: e(t)("拉绳长度（毫米）"),
                                  path: "ropeLength"
                                }, {
                                  default: s(() => [
                                    l(e(F), {
                                      disabled: !e(p)(e(d), "ropeLength"),
                                      value: e(a).ropeLength,
                                      "onUpdate:value": o[3] || (o[3] = (n) => e(a).ropeLength = n),
                                      "show-button": !1,
                                      min: 0,
                                      class: "tw:!w-[50%]"
                                    }, null, 8, ["disabled", "value"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            l(e(m), { span: 12 }, {
                              default: s(() => [
                                l(e(f), {
                                  label: e(t)("安装方式"),
                                  path: "installationMethod"
                                }, {
                                  default: s(() => [
                                    l(e(y), {
                                      disabled: !e(p)(e(d), "installationMethod"),
                                      value: e(a).installationMethod,
                                      "onUpdate:value": o[4] || (o[4] = (n) => e(a).installationMethod = n),
                                      placeholder: e(t)("请选择安装方式"),
                                      options: w("installationMethod"),
                                      "label-field": "value",
                                      "value-field": "valueCode",
                                      "key-field": "valueCode",
                                      clearable: "",
                                      class: "tw:!w-full tw:!text-left",
                                      to: !1
                                    }, null, 8, ["disabled", "value", "placeholder", "options"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            l(e(m), { span: 12 }, {
                              default: s(() => [
                                l(e(f), {
                                  label: e(t)("手动拉绳安装位置"),
                                  path: "manualRopeInstallPosition"
                                }, {
                                  default: s(() => [
                                    l(e(y), {
                                      disabled: !e(p)(e(d), "manualRopeInstallPosition"),
                                      value: e(a).manualRopeInstallPosition,
                                      "onUpdate:value": o[5] || (o[5] = (n) => e(a).manualRopeInstallPosition = n),
                                      placeholder: e(t)("请选择手动拉绳安装位置"),
                                      options: w("manualRopeInstallPosition"),
                                      "label-field": "value",
                                      "value-field": "valueCode",
                                      "key-field": "valueCode",
                                      clearable: "",
                                      class: "tw:!w-full tw:!text-left",
                                      to: !1
                                    }, null, 8, ["disabled", "value", "placeholder", "options"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            l(e(m), { span: 12 }, {
                              default: s(() => [
                                l(e(f), {
                                  label: e(t)("电机安装位置"),
                                  path: "machineInstallPosition"
                                }, {
                                  default: s(() => [
                                    l(e(y), {
                                      disabled: !e(p)(e(d), "machineInstallPosition"),
                                      value: e(a).machineInstallPosition,
                                      "onUpdate:value": o[6] || (o[6] = (n) => e(a).machineInstallPosition = n),
                                      placeholder: e(t)("请选择电机安装位置"),
                                      options: w("machineInstallPosition"),
                                      "label-field": "value",
                                      "value-field": "valueCode",
                                      "key-field": "valueCode",
                                      clearable: "",
                                      class: "tw:!w-full tw:!text-left",
                                      to: !1
                                    }, null, 8, ["disabled", "value", "placeholder", "options"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            l(e(m), { span: 12 }, {
                              default: s(() => [
                                l(e(f), {
                                  label: e(t)("开合方式"),
                                  path: "openModel"
                                }, {
                                  default: s(() => [
                                    l(e(y), {
                                      disabled: !e(p)(e(d), "openModel"),
                                      value: e(a).openModel,
                                      "onUpdate:value": o[7] || (o[7] = (n) => e(a).openModel = n),
                                      placeholder: e(t)("请选择开合方式"),
                                      options: w("openModel"),
                                      "label-field": "value",
                                      "value-field": "valueCode",
                                      "key-field": "valueCode",
                                      clearable: "",
                                      class: "tw:!w-full tw:!text-left",
                                      to: !1
                                    }, null, 8, ["disabled", "value", "placeholder", "options"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            l(e(m), { span: 12 }, {
                              default: s(() => [
                                l(e(f), {
                                  label: e(t)("配送方式"),
                                  path: "deliveryMethod"
                                }, {
                                  default: s(() => [
                                    l(e(y), {
                                      disabled: !e(p)(e(d), "deliveryMethod"),
                                      value: e(a).deliveryMethod,
                                      "onUpdate:value": o[8] || (o[8] = (n) => e(a).deliveryMethod = n),
                                      placeholder: e(t)("请选择配送方式"),
                                      options: w("deliveryMethod"),
                                      "label-field": "value",
                                      "value-field": "valueCode",
                                      "key-field": "valueCode",
                                      clearable: "",
                                      class: "tw:!w-full tw:!text-left",
                                      to: !1
                                    }, null, 8, ["disabled", "value", "placeholder", "options"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            l(e(m), { span: 12 }, {
                              default: s(() => [
                                l(e(f), {
                                  label: e(t)("是否加急"),
                                  path: "urgent"
                                }, {
                                  default: s(() => [
                                    l(e(me), {
                                      disabled: !e(p)(e(d), "urgent"),
                                      value: e(a).urgent,
                                      "onUpdate:value": o[9] || (o[9] = (n) => e(a).urgent = n)
                                    }, {
                                      default: s(() => [
                                        l(e(O), { value: "是" }, {
                                          default: s(() => [
                                            M(C(e(t)("是")), 1)
                                          ]),
                                          _: 1
                                        }),
                                        l(e(O), { value: "否" }, {
                                          default: s(() => [
                                            M(C(e(t)("否")), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["disabled", "value"]),
                                    R("span", ce, "  (" + C(e(t)("注：加急需收取加急费35元")) + ") ", 1)
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            l(e(m), { span: 24 }, {
                              default: s(() => [
                                l(e(f), {
                                  label: e(t)("备注"),
                                  path: "remark"
                                }, {
                                  default: s(() => [
                                    l(e(E), {
                                      disabled: !e(p)(e(d), "remark"),
                                      value: e(a).remark,
                                      "onUpdate:value": o[10] || (o[10] = (n) => e(a).remark = n),
                                      type: "textarea",
                                      placeholder: "请填写具体下单尺寸要求",
                                      clearable: "",
                                      class: "tw:!w-[80%]"
                                    }, null, 8, ["disabled", "value"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            l(e(m), { span: 24 }, {
                              default: s(() => [
                                l(e(f), {
                                  label: e(t)("附件"),
                                  path: "attachments"
                                }, {
                                  default: s(() => [
                                    l(v, {
                                      value: e(a).attachments,
                                      "onUpdate:value": o[11] || (o[11] = (n) => e(a).attachments = n),
                                      "business-type": "handbill",
                                      maxLength: 10,
                                      disabled: !e(p)(e(d), "attachments"),
                                      isDelete: !0
                                    }, null, 8, ["value", "disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        R("div", ve, [
                          l(e(T), { onClick: S }, {
                            default: s(() => [
                              M(C(e(t)("取消")), 1)
                            ]),
                            _: 1
                          }),
                          l(e(T), {
                            type: "primary",
                            onClick: q
                          }, {
                            default: s(() => [
                              M(C(e(t)("确定")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["model", "rules"])
                  ]),
                  _: 1
                }, 8, ["show"])
              ]),
              _: 1
            }, 8, ["title"])
          ]),
          _: 1
        }, 8, ["show", "to"])
      ], 64);
    };
  }
});
export {
  Ee as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/guahuabihua/guahuabihua.vue2.js
// module id = 1212
// module chunks = 41